import { Folder, FolderOpen, File, FileText, FileSpreadsheet, FileCode, Image } from "lucide-react";

export function fileIcon(item) {
  if (item.type === "folder") return null;
  const ext = (item.extension || "").toLowerCase();
  const cls = "w-10 h-10 flex-shrink-0 flex items-center justify-center";
  if (["csv", "tsv"].includes(ext))
    return <div className={`${cls} bg-emerald-50`}><FileSpreadsheet className="w-5 h-5 text-emerald-600" /></div>;
  if (["xlsx", "xls"].includes(ext))
    return <div className={`${cls} bg-emerald-50`}><FileSpreadsheet className="w-5 h-5 text-emerald-700" /></div>;
  if (ext === "pdf")
    return <div className={`${cls} bg-red-50`}><FileText className="w-5 h-5 text-red-500" /></div>;
  if (["py", "js", "ts", "sql", "json", "xml", "yaml"].includes(ext))
    return <div className={`${cls} bg-blue-50`}><FileCode className="w-5 h-5 text-blue-500" /></div>;
  if (["png", "jpg", "jpeg", "svg", "gif", "webp"].includes(ext))
    return <div className={`${cls} bg-purple-50`}><Image className="w-5 h-5 text-purple-500" /></div>;
  if (["txt", "md"].includes(ext))
    return <div className={`${cls} bg-gray-50`}><FileText className="w-5 h-5 text-gray-500" /></div>;
  return <div className={`${cls} bg-[#F5F4EE]`}><File className="w-5 h-5 text-[#A8A67A]" /></div>;
}

export function fmtSize(bytes) {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1048576).toFixed(1)} MB`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
}

export function pathSegments(path) {
  const segs = path.split("/").filter(Boolean);
  return [
    { label: "Ellerston Drive", path: "/" },
    ...segs.map((s, i) => ({ label: s, path: "/" + segs.slice(0, i + 1).join("/") })),
  ];
}
